import React from 'react'
import LapKeuanganPage from '../../modules/admintbk/LapKeuanganPage'

const LaporanHarian = ()=> {
  return (
    <LapKeuanganPage></LapKeuanganPage>
    )
}

export default LaporanHarian